/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { MarkReservationCreditPurchasePaidPathParameters } from 'api/actions/mark-reservation-credit-purchase-paid/mark-reservation-credit-purchase-paid-path-parameters';
import { MarkReservationCreditPurchasePaidResponse } from 'api/actions/mark-reservation-credit-purchase-paid/mark-reservation-credit-purchase-paid-response';

type MarkReservationCreditPurchasePaidQueryParameters = Record<string, any>;

/**
 * The path of the MarkReservationCreditPurchasePaid action.
 */
export const markReservationCreditPurchasePaidActionPath = new SweetPath<
  keyof MarkReservationCreditPurchasePaidPathParameters
>('/admin/custom/reservation-credit-purchases/{purchaseId}/mark-paid', { path: '{param}' });

/**
 * Creates a contextualized MarkReservationCreditPurchasePaid actions.
 */
export default function createMarkReservationCreditPurchasePaidAction(axios: AxiosInstance) {
  return function markReservationCreditPurchasePaidAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: MarkReservationCreditPurchasePaidPathParameters;
    query?: MarkReservationCreditPurchasePaidQueryParameters;
  }) {
    const path = markReservationCreditPurchasePaidActionPath.insert(parameters);

    return axios.post<MarkReservationCreditPurchasePaidResponse, MarkReservationCreditPurchasePaidResponse>(path, {
      params: query,
      headers,
    });
  };
}
